<template>
    <div>
        <!-- cart review information title -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="p-2 bg-silver">
                        <!-- cart details -->
                        <div class="float-left">
                            <p class="m-0 font-weight-bold">
                                <i class="fas fa-shopping-cart mr-2"></i> 
                                <app-cart-counter></app-cart-counter> Cart Items 
                            </p>
                        </div>
                        <div class="float-right">
                            <p class="m-0 p-0 text-dark-green font-weight-bold">
                                <app-cart-sum-price></app-cart-sum-price>
                            </p>
                        </div>
                        <div class="clearfix"></div>
                        
                        <!-- shopper details -->
                        <div v-if="activeShopper" class="d-block">
                            <hr class="my-1">
                            <div class="scroll-box-horizontally">
                                <p class="m-0 text-capitalize">
                                    <i class="fas fa-user mr-2"></i> {{activeShopper.firstName}} {{activeShopper.lastName}}
                                </p>
                                <p v-if="activeShopper.phone" class="my-0">
                                    <i class="fas fa-tty mr-2"></i> {{activeShopper.phone}}
                                </p>
                                <p class="my-0"><i class="fas fa-envelope mr-2"></i> {{activeShopper.email}}</p>
                                <p class="my-0">
                                    <i class="fas fa-shipping-fast mr-1"></i> 
                                    {{activeShopper.address}}, 
                                    {{activeShopper.address2 ? activeShopper.address2 + ',' : ''}} 
                                    {{activeShopper.city | capitalize}}, 
                                    {{activeShopper.state | capitalize}}, 
                                    {{activeShopper.country | capitalize}}, 
                                    {{activeShopper.zipCode}} 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartCounter from '../homeParts/CartCounter.vue'
import CartSumPrice from '../homeParts/CartSumPrice.vue'

export default {
    name: "CartReview",
    data() {
        return {
            activeShopper: null
        }
    },
    methods: {
        activeShopperFxn() {
            // check if user already have a shopper details storage on local-storage
            let localStorageSHPDetails = JSON.parse(localStorage.getItem('ani_items_shp')) 
            if(localStorageSHPDetails) { 
                this.activeShopper = localStorageSHPDetails 
            }
        }
    },
    components: {
        appCartCounter: CartCounter,
        appCartSumPrice: CartSumPrice
    },
    created() {
        this.activeShopperFxn()
    }
}
</script>
